export const urlToFile = async (url: string): Promise<File | null> => {
	if (!url) {
		return Promise.resolve(null);
	}

	const response = await fetch(url);
	const blob = await response.blob();
	return new File([blob], "image.jpg", { type: blob.type });
};

export const urlToBase64 = async (url: string): Promise<string | null> => {
	if (!url) {
		return Promise.resolve(null);
	}

	const response = await fetch(url);
	const blob = await response.blob();
	return new Promise((resolve) => {
		const reader = new FileReader();
		reader.onloadend = () => {
			resolve(reader.result as string);
		};
		reader.readAsDataURL(blob);
	});
};

export const downloadBlob = (
	data: BlobPart,
	fileName = "report.pdf",
	mimeType = "application/pdf"
) => {
	const blob = new Blob([data], { type: mimeType });
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = url;
	link.download = fileName;
	link.click();
};
